export class Time {
  elapsed = 0;
  dt = 0;
  unscaledDt = 0;
  frame = 0;
  scale = 1;
  readonly maxDt: number;

  constructor(maxDt = 0.05) {
    this.maxDt = maxDt;
  }

  tick(rawDtSeconds: number): void {
    this.unscaledDt = Math.min(rawDtSeconds, this.maxDt);
    this.dt = this.unscaledDt * this.scale;
    this.elapsed += this.dt;
    this.frame += 1;
  }

  reset(): void {
    this.elapsed = 0;
    this.dt = 0;
    this.unscaledDt = 0;
    this.frame = 0;
  }
}
